import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider } from "@material-ui/core";
import { isNil } from 'lodash';
import ShowTicketOpen from '../ShowTicketOpenModal';

const VcardPreview = ({ contact, numbers, queueId, whatsappId, channel }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [loading, setLoading] = useState(true);

    const [selectedContact, setContact] = useState({
        id: 0,
        name: "",
        number: "",
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    if (isNil(numbers) || !numbers) {
                        if (contact) {
                            setContact(prev => ({ ...prev, name: contact }));
                        }
                        setLoading(false);
                        return;
                    }
                    const number = numbers.replace(/\D/g, "");
                    if (!number) {
                        if (contact) {
                            setContact(prev => ({ ...prev, name: contact, number: numbers }));
                        }
                        setLoading(false);
                        return;
                    }
                    const getData = await api.get(`/contacts/profile/${number}`, { params: { channel: channel } });

                    if (getData.data.contactId && getData.data.contactId !== 0) {
                        setContact({
                            id: getData.data.contactId,
                            name: contact,
                            number: number,
                            urlPicture: getData.data.urlPicture
                        });
                    } else {
                        const { data } = await api.post("/contacts", {
                            name: contact,
                            number: number,
                            email: "",
                            companyId: companyId
                        });
                        setContact(data);
                    }

                } catch (err) {
                    console.log(err);
                    if (contact || numbers) {
                        setContact(prev => ({ ...prev, name: contact || prev.name, number: numbers?.replace(/\D/g, "") || prev.number }));
                    }
                } finally {
                    setLoading(false);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [companyId, contact, numbers]);

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");
    };

    const handleNewChat = async () => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                queueId,
                companyId: companyId,
                whatsappId
            });

            history.push(`/tickets/${ticket.uuid}`);
        } catch (err) {
            try {
                const ticket = JSON.parse(err.response.data.error);

                if (ticket.userId !== user?.id) {
                    setOpenAlert(true);
                    setUserTicketOpen(ticket?.user?.name);
                    setQueueTicketOpen(ticket?.queue?.name);
                } else {
                    setOpenAlert(false);
                    setUserTicketOpen("");
                    setQueueTicketOpen("");

                    history.push(`/tickets/${ticket.uuid}`);
                }
            } catch (parseErr) {
                console.error("Erro ao iniciar conversa:", err);
                toastError(err);
            }
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar src={`${selectedContact?.urlPicture}`} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography
                            style={{ marginTop: "12px", marginLeft: "10px" }}
                            color="primary"
                            variant="subtitle1"
                            gutterBottom
                        >
                            {selectedContact.name || contact}
                        </Typography>
                        {(selectedContact.number) && (
                            <Typography
                                style={{ marginLeft: "10px", marginTop: "-8px" }}
                                color="textSecondary"
                                variant="body2"
                            >
                                {selectedContact.number}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={loading || !selectedContact.id}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;